import * as React from 'react';
import { observer } from 'mobx-react';
import { inject } from '../../utils';
import { withTheme } from 'styled-components';
import { FeedbackProps } from './Models';
import Toaster from './Components/Toaster';
import Alert from './Components/Alert';

@inject('dataStore', 'feedbackStore')
@observer
class Feedback extends React.Component<FeedbackProps> {
    constructor(props: FeedbackProps) {
        super(props);
    }

    render() {
        const { feedbackStore } = this.props;
        return (
            <React.Fragment>
                <Alert feedbackStore={feedbackStore} />
                <Toaster feedbackStore={feedbackStore} />
            </React.Fragment>
        );
    }
}

export default withTheme(Feedback) as any;



// WEBPACK FOOTER //
// ./src/Components/Feedback/Feedback.tsx